import React from 'react'
import { StackView } from '@planningcenter/tapestry-react'
import { Code, CodeBlock, PageHeading, Text } from '../../../shared/typography'

export default function page() {
  return (
    <StackView axis="vertical" spacing={2}>
      <PageHeading>Current User</PageHeading>

      <Text>
        To identify the current user, you can use the <Code>/me</Code> endpoint
        in any application API or the <Code>/current/v2/me</Code> endpoint from
        the Current API. For example:
      </Text>

      <CodeBlock language="bash">
        {`
curl https://api.planningcenteronline.com/people/v2/me -H 'Authorization: Bearer ...'
curl https://api.planningcenteronline.com/current/v2/me -H 'Authorization: Bearer ...'
        `.trim()}
      </CodeBlock>

      <Text>
        When using an application API, the <Code>/me</Code>
        endpoint requires the application's OAuth scope and enforces the current
        user's access and permissions within that application. The
        <Code>/current/v2/me</Code> endpoint, however, is available to all OAuth
        applications without requiring any scopes and without imposing any
        access or permission rules to the user account.
      </Text>
    </StackView>
  )
}
